<template>
    <!--成绩单-->
  <div id="scorelist">
    <div class="title">
      <div>用户名称</div>
      <div>学科/科目</div>
      <div>总分</div>
    </div>
    <vue-seamless-scroll :data="listData" :class-option="classOption" class="seamless-warp">
      <ul class="item">
        <li v-for="(item, index) in listData" :key="index">
          <div v-text="item.name"></div><div v-text="item.subject"></div><div class="red" v-text="item.score"></div>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
export default {
  name: 'scoreList',
  data () {
    return {
      listData: [{
        'name': '李**',
        'subject': '语文',
        'score': '合格'
      }, {
        'name': '徐**',
        'subject': '英语',
        'score': '合格'
      }, {
        'name': '杨**',
        'subject': '幼儿',
        'score': '合格'
      }, {
        'name': '唐**',
        'subject': '语文',
        'score': '合格'
      }, {
        'name': '孙**',
        'subject': '数学',
        'score': '合格'
      }, {
        'name': '徐**',
        'subject': '体育',
        'score': '合格'
      }, {
        'name': '杨**',
        'subject': '音乐',
        'score': '合格'
      }, {
        'name': '唐**',
        'subject': '幼儿',
        'score': '合格'
      }, {
        'name': '田**',
        'subject': '体育',
        'score': '合格'
      }]
    }
  },
  computed: {
    classOption () {
      return {
        direction: 1,
        step: 0.5
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .seamless-warp {
    height: 229px;
    overflow: hidden;
  }
  #scorelist
    background: #fff
    .title
      display: flex
      justify-content: space-between
      align-items: center
      & > div
        width: 1.5rem
        height: 1rem
        line-height: 1rem
        font-size: .32rem
        color: #333
        font-weight: 700
        text-align: center
    ul
      li
        display: flex
        justify-content: space-between
        align-items: center
        height: .59rem
        border-top: .02rem solid #F3F4F5
        & > div
          width: 1.5rem
          height: .59rem
          line-height: .59rem
          font-size: .3rem
          color: #333
          text-align: center
          &.red
            color: #FF7052
</style>



// WEBPACK FOOTER //
// src/components/share/plug/scoreList.vue